import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from 'react-i18next';
import { signupCopy } from '@/Pages/Signup/copy';
import { COMMON_NAMESPACE } from '@/i18n';
import '@/Pages/Signup/SignupPage.sass';

type SignupCtaProps = {
  disabled: boolean;
  isSubmitting: boolean;
  onSubmit: () => Promise<void>;
};

export function SignupCta({
  disabled,
  isSubmitting,
  onSubmit,
}: SignupCtaProps): JSX.Element {
  const { t } = useTranslation(COMMON_NAMESPACE);

  return (
    <Box className="signup-cta" data-testid="signup-cta">
      <Button
        type="button"
        variant="contained"
        color="primary"
        fullWidth
        disabled={disabled || isSubmitting}
        aria-busy={isSubmitting}
        loading={isSubmitting}
        className="signup-cta__button"
        loadingIndicator={
          <CircularProgress
            size={22}
            aria-label={t('loading')}
            className="signup-cta__loader"
          />
        }
        loadingPosition="end"
        onClick={() => {
          void onSubmit();
        }}
        endIcon={
          isSubmitting ? undefined : (
            <ArrowForwardRoundedIcon aria-hidden fontSize="small" />
          )
        }
      >
        {isSubmitting ? signupCopy.ctaLoading : signupCopy.cta}
      </Button>
    </Box>
  );
}
